import { rd } from '@passionware/monads';
import { MainSidebar } from 'v5/features/core/MainSidebar';
import {
  EnterpriseMainSidebar,
  EnterpriseMainSidebarProps
} from 'v5/features/core/EnterpriseMainSidebar';
import { SettingsSidebar } from 'v5/features/core/SettingsSidebar';
import {
  EnterpriseSettingsSidebar,
  EnterpriseSettingsSidebarProps
} from 'v5/features/core/EnterpriseSettingsSidebar';
import { WithFeatureService } from 'v5/services/front/FeatureService/FeatureService';
import { WithServices } from 'v5/platform/ts/services';

export type AppSettingsSidebarProps = EnterpriseSettingsSidebarProps &
  WithServices<[WithFeatureService]>;

export function AppMainSidebar(props: EnterpriseMainSidebarProps) {
  const isEnterprise = rd.getOrElse(
    props.services.featureService.useFeature('enterprise'),
    false
  );

  if (isEnterprise) {
    return (
      <EnterpriseMainSidebar
        services={props.services}
        className={props.className}
      />
    );
  }

  return <MainSidebar {...props} />;
}

export function AppSettingsSidebar(props: AppSettingsSidebarProps) {
  const isEnterprise = rd.getOrElse(
    props.services.featureService.useFeature('enterprise'),
    false
  );

  if (isEnterprise) {
    return (
      <EnterpriseSettingsSidebar
        services={props.services}
        className={props.className}
      />
    );
  }

  return <SettingsSidebar {...props} />;
}
